<template>
  <div class="board trip-board audience-trip">
    <user-nav />
    <div class="tile is-ancestor">
      <div class="tile is-5 is-parent is-vertical">
        <div class="tile is-child">
          <trip-map />
        </div>
        <div class="tile is-child">
          <trip-summary ref="summary" />
        </div>
      </div>
      <div class="tile is-7 is-parent is-vertical is-dark">
        <div class="tile is-child">
          <trip-overview ref="overview" />
        </div>
        <div class="tile is-child">
          <trip-details ref="details" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserNav from '../user/modules/UserNav';
import TripMap from './modules/TripMap';
import TripSummary from './modules/TripSummary';
import TripDetails from './modules/TripDetails';
import TripOverview from './modules/TripOverview';
import store from 'store/index';
import { configs } from 'config';

export default {
  name: 'AudienceTrip',

  components: {
    UserNav,
    TripMap,
    TripSummary,
    TripDetails,
    TripOverview,
  },

  beforeRouteEnter(to, from, next) {
    const id = to.params.userId;
    const start = to.params.tripStart;
    const day = String(start.match(/\d{4}-\d{2}-\d{2}/));

    Promise.all([
      store.dispatch('user/loadUser', { id, day }),
      store.dispatch('trip/loadTrip', { id, start }),
    ]).then(next);
  },
};
</script>

<style lang="scss">
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.audience-trip {
  .card {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .card-header {
    align-items: center;
    padding: 0.796875rem 1rem;

    &.has-tabs {
      padding-top: 0.515625rem;
      padding-bottom: 0.515625rem;
    }

    &.has-dropdown {
      padding-top: 0.515625rem;
      padding-bottom: 0.515625rem;
    }

    .level {
      flex: 1;
    }

    .tooltip-container {
      margin-left: 0.375rem;

      i {
        font-size: $size-small;
        opacity: 0.72;
      }
    }
  }

  .card-header-title {
    margin-top: 0;
  }
}
</style>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.tile {
  &.is-ancestor {
    min-height: calc(100vh - 104px);
    margin: 0;
  }

  &.is-child {
    flex: 1;
  }

  &.is-dark {
    background-color: rgba($black, 0.12);
  }

  &.has-margin-left {
    margin-left: 0.5rem;
  }
}
</style>
